// src/hooks/hotelRoomCategories/useDeleteAllHotelRoomCategories.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAllHotelRoomCategories as deleteAllHotelRoomCategoriesAPI } from "../../api/apiHotelRoomCategories";
import parseError from "../../utils/parseError";

const useDeleteAllHotelRoomCategories = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteAll, isPending: isDeleteAll } = useMutation({
        mutationFn: deleteAllHotelRoomCategoriesAPI,
        onSuccess: (res) => {
            const message = res?.message || "Selected hotel room categories deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelRoomCategories"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete selected hotel room categories");
        },
    });

    return { deleteAllHotelRoomCategories: deleteAll, isDeleteAll };
};

export default useDeleteAllHotelRoomCategories;
